'use client';

import { Button } from '@/components/ui/button';
import React, { useState } from 'react';
import { useSecurePayment } from '@/hooks/useSecurePayment';
import { getEnv } from '@/lib/env';

const PaymentButton = () => {
  const [isProcessing, setIsProcessing] = useState(false);
  const { processSecurePayment, loading, error } = useSecurePayment();

  // Enable secure payment - can be controlled via environment variable
  const USE_SECURE_PAYMENT =
    getEnv('VITE_SECURE_PAYMENT', 'true') === 'true';

  const handlePayment = async () => {
    if (isProcessing || loading) return;

    try {
      setIsProcessing(true);

      if (USE_SECURE_PAYMENT) {
        // Secure payment flow
        const userInfo = JSON.parse(sessionStorage.getItem('user') || '{}');
        const authToken = sessionStorage.getItem('token') || '';

        await processSecurePayment({
          amount: 8404.0,
          user_info: {
            user_id: userInfo.user_id || userInfo.agencyId,
            email: userInfo.email,
            phone: userInfo.phone || '9999999999',
            agency_name: userInfo.agency_name || 'Customer',
            agent_id: userInfo.agent_id || 'GUEST',
          },
          trackId: Date.now().toString(), // Generate or get from context
          type: 'booking',
          auth: authToken,
        });

        console.log('Secure payment processed successfully');
      } else {
        // Legacy flow - fallback
        console.log('Using legacy payment flow');
      }
    } catch (err) {
      console.error('Payment failed:', err);
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <div className="mt-8 text-right">
      <Button
        onClick={handlePayment}
        disabled={isProcessing || loading}
        className="w-52 rounded-3xl text-white"
      >
        {isProcessing || loading ? 'Processing...' : 'Pay ₹8,404.00'}
      </Button>
      {error && <div className="mt-2 text-sm text-red-500">{error}</div>}
    </div>
  );
};

export default PaymentButton;
